import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=05af49ae&scoped=true&lang=html&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=05af49ae&lang=scss&scoped=true&"
import style1 from "./Favorites.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af49ae",
  null
  
)

export default component.exports